import React from 'react';

function HeartNoFillSvg({ className, isRef, viewBox }) {
  viewBox = viewBox || '0 0 48 43';
  return (
    <svg
      ref={isRef}
      className={className}
      width="38"
      height="33"
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M42.3612 6.17537C41.306 5.11977 40.0533 4.28239 38.6745 3.71107C37.2957 3.13976 35.8178 2.8457 34.3253 2.8457C32.8328 2.8457 31.3549 3.13976 29.9761 3.71107C28.5973 4.28239 27.3446 5.11977 26.2895 6.17537L24.0997 8.36508L21.91 6.17537C19.7788 4.04413 16.8882 2.84681 13.8742 2.84681C10.8601 2.84681 7.96956 4.04413 5.83832 6.17537C3.70708 8.30661 2.50977 11.1972 2.50977 14.2112C2.50977 17.2252 3.70708 20.1158 5.83832 22.2471L8.02804 24.4368L24.0997 40.5085L40.1714 24.4368L42.3612 22.2471C43.4168 21.192 44.2541 19.9392 44.8254 18.5604C45.3968 17.1816 45.6908 15.7037 45.6908 14.2112C45.6908 12.7187 45.3968 11.2408 44.8254 9.86203C44.2541 8.48322 43.4168 7.23047 42.3612 6.17537Z"
        stroke="#800020"
        strokeWidth="4.13154"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeartNoFillSvg;
